export const LANGUAGE_CHOICES = ['en', 'hi'] as const;
export type LanguageChoice = (typeof LANGUAGE_CHOICES)[number];

export const LANGUAGE_NAMES: Readonly<Record<LanguageChoice, string>> = {
  en: 'English',
  hi: 'हिंदी',
};

export const LANGUAGE_SHORT: Readonly<Record<LanguageChoice, string>> = {
  en: 'EN',
  hi: 'हिं',
};

export const languageChoiceOf = (code: string | null | undefined): LanguageChoice =>
  code?.toLowerCase().startsWith('hi') ? 'hi' : 'en';

/** The language the app is showing right now. */
export const languageInUse = (i18n: { readonly resolvedLanguage?: string; readonly language: string }): LanguageChoice =>
  languageChoiceOf(i18n.resolvedLanguage ?? i18n.language);
